module.exports = __webpack_public_path__ + "static/DetectiveGui1-0aa9787f43d9c63e6e86b4ec683c1013.png";